import { ShieldCheck, Clock, Handshake, HeartHandshake, Lightbulb, CheckCircle2 } from "lucide-react";

const reasons = [
  { icon: ShieldCheck, title: "Zweryfikowani artyści", description: "Każdy wykonawca przechodzi rygorystyczny proces selekcji i weryfikacji referencji" },
  { icon: Handshake, title: "Indywidualne podejście", description: "Dobieramy atrakcje pod specyfikę branży, kulturę organizacyjną i charakter eventu" },
  { icon: Clock, title: "Niezawodność terminów", description: "Gwarantujemy punktualność i pełną gotowość artystów na każdym wydarzeniu" },
  { icon: HeartHandshake, title: "Satysfakcja gwarantowana", description: "Jeśli atrakcja nie spełni oczekiwań - zwrócimy pieniądze bez zbędnych formalności" },
  { icon: Lightbulb, title: "Kreatywne koncepcje", description: "Nasz zespół kreatywny projektuje unikalne scenariusze dopasowane do Twojej wizji" },
  { icon: CheckCircle2, title: "Sprawdzone rozwiązania", description: "Bazujemy na doświadczeniu z setek zrealizowanych eventów korporacyjnych" },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="py-24 section-blue relative overflow-hidden">
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Nasza <span className="text-gradient">przewaga</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Co sprawia, że Klienci do nas wracają?
        </p>
        <div className="grid md:grid-cols-3 gap-5">
          {reasons.map((reason) => {
            const Icon = reason.icon;
            return (
              <div key={reason.title} className="card-elevated p-6 hover:border-accent/20 hover:-translate-y-1 group">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/15 transition-colors">
                  <Icon className="w-6 h-6 text-accent" />
                </div>
                <h3 className="text-lg font-outfit font-bold mb-2 text-foreground">{reason.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
